import { QUESTION, RESET } from '../actions/types';

const initialState = {
  seenHallucinations: false,
  falseBeliefs: false,
  experienceAffectingActivities: false,
  insuranceStatus: null,
  hipaa: false,
  patientSignatureDate: false,
  dob: false,
  personalRepresentative: null,
  personalRepresentativeDate: false
}

export default function(state = initialState, action) {
  switch (action.type) {
    case QUESTION:
      return Object.assign({}, state, {
        ...state,
        [action.payload.name]: action.payload.value
      });
    case RESET:
      return initialState;
    default:
      return state;
  }
}